var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVariants = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7.2,
  cy: 7.2,
  r: 3.2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.2,
  cy: 16.8,
  r: 3.2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.8,
  cy: 7.2,
  r: 3.2
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.8,
  cy: 16.8,
  r: 3.2
})));
export default SvgVariants;